import React from "react";
import { Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

import EditableFieldsTable from "components/Records/RecordDisplay/EditableFieldsTable";

import { Organisation } from "api/Accounts/AccountsInterfaces";

interface OrganisationDetailsTabProps {
  organisation: Organisation;
  organisationID: number | null;
  onUpdate: (
    id: number,
    field: keyof Organisation,
    value: any
  ) => Promise<void>;
}

const OrganisationDetailsTab: React.FC<
  OrganisationDetailsTabProps
> = ({
  organisation,
  organisationID,
  onUpdate,
}) => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Typography variant="h6" gutterBottom>
          Contact Details
        </Typography>

        <EditableFieldsTable<Organisation>
          record={organisation}
          fields={[
            {
              field: "email",
              label: "Email",
            },
            {
              field: "phone_number",
              label: "Phone Number",
            },
            {
              field: "address",
              label: "Address",
              multiline: true,
            },
            {
              field: "website",
              label: "Website",
            },
          ]}
          onSave={(field, value) =>
            onUpdate(
              Number(organisationID),
              field,
              value
            )
          }
        />
      </Grid2>

      <Grid2 size={{ xs: 12, md: 6 }}>
        <Typography variant="h6" gutterBottom>
          Demographic Details
        </Typography>

        <EditableFieldsTable<Organisation>
          record={organisation}
          fields={[
            {
              field: "denomination",
              label: "Denomination",
            },
            {
              field: "size_on_record",
              label: "Nominal Number of People",
            },
            {
              field: "size_at_service",
              label:
                "Number of People at a Typical Gathering",
            },
          ]}
          onSave={(field, value) =>
            onUpdate(
              Number(organisationID),
              field,
              value
            )
          }
        />
      </Grid2>
    </Grid2>
  );
};

export default OrganisationDetailsTab;